module.exports = __webpack_public_path__ + "img/collapse-closed.svg";